export default __webpack_public_path__ + "static/media/kettle.54f3e88b.svg";